module.exports = " <div class=counter :class=\"`counter--${modifier}`\"> <button @click=\"counter += 1\" type=button aria-label=increment>+</button> <input v-model=counter type=text disabled=true /> <button @click=\"counter -= 1\" type=button aria-label=decrement>-</button> </div> ";


/*****************
 ** WEBPACK FOOTER
 ** ./~/vue-html-loader!./~/vue-loader/lib/selector.js?type=template&index=0!./src/component.vue
 ** module id = 85
 ** module chunks = 1
 **/